<template>
  <v-dialog
    v-model="showModal"
    max-width="565"
    @click:outside="persistent ? null : $emit('onClose')"
    @keydown.esc="persistent ? null : $emit('onClose')"
    :persistent="persistent"
  >
    <v-card style="background-color: #1a1a1a" class="ma-0" outlined>
      <v-row class="mr-6 ml-6 mb-0 pb-0">
        <v-col v-if="title" class="pa-0">
          <h1 class="pa-0 mt-6">{{ title }}</h1>
        </v-col>
        <v-icon
          v-if="!autoClose && showClose"
          @click="$emit('onClose')"
          class="mt-7 mr-1"
        >
          $iconClose
        </v-icon>
      </v-row>
      <v-row class="mr-6 ml-6 mt-2" justify="center">
        <v-col class="ml-0 mr-0 pa-0" max-width="514"> <slot></slot> </v-col
      ></v-row>
      <v-row
        class="mr-6 ml-6 pb-5 mt-3"
        justify="end"
        v-if="secondaryButtonText || primaryButtonText"
      >
        <v-card-actions class="ma-0 pa-0">
          <niko-button
            v-if="secondaryButtonText"
            plain
            :text="secondaryButtonText"
            @onClick="$emit('onClose')"
          ></niko-button>
          <niko-button
            class="ml-4"
            v-if="primaryButtonText"
            :text="primaryButtonText"
            @onClick="$emit('onSubmit')"
            primary
          ></niko-button>
        </v-card-actions>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import NikoButton from "./NikoButton";

export default {
  name: "niko-modal-wrapper",
  components: { NikoButton },
  props: {
    title: String,
    showModal: Boolean,
    primaryButtonText: String,
    secondaryButtonText: String,
    autoClose: Boolean,
    persistent: Boolean,
  },
  computed: {
    showClose() {
      return this.$listeners && this.$listeners.onClose;
    },
  },
};
</script>
<style scoped>
.v-text-field--filled:not(.v-text-field--single-line) input {
  margin-top: 1px;
}
.v-subheader {
  color: white;
}
.v-label {
  color: white;
}
.v-input__control {
  align-items: center;
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 16px;
}
.theme--dark.v-card.v-card--outlined {
  border: thin solid rgba(255, 255, 255, 0.5);
}
</style>
